import { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./NewsCarousel.css";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import { Image, SimpleGrid} from "@mantine/core";
import { Link } from "react-router-dom";
import { getRelativeDate } from "../../../../utils/getRelativeDate";
import { IconArrowRight, IconUsers } from "@tabler/icons-react";



const NewsCarousel = () => {

    const [newsdata, setNewsData] = useState([]);

    const fetchData = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/blog`);

            const formatedResponse = data.map((article) => {
                return {
                    title: article.title,
                    content: article.content,
                    image: article.image,
                    href: `/blog/${article.slugName}`,
                    tags: article.tags?.slice(0,3) || [],
                    category: article.category,
                    views: article.views,
                    date: article.date,
                };
            });
            setNewsData(formatedResponse.slice(0, 3));

        } catch (error) {
            console.error("Error fetching news data:", error);
        }
    };


    useEffect(() => {
        fetchData();
    }, []);


    if(!newsdata || newsdata?.length === 0) return <></>

    return (
        <div id='que-esta-pasando' className="div-container-newscarousel">
            <SectionTitle upText="Actividad reciente" downText="Qué está pasando en FORVET" />
            <p className="div-container-newscarousel--description">La comunidad no para. Estos son los últimos debates, sesiones y descubrimientos de nuestros veterinarios.</p>
             <Link to='/blog' className="hc-link">Ver más →</Link>
            <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} mt={30}>
                {newsdata?.map(item => <Card
                    tags={item.tags}
                    title={item.title}
                    content={item.content}
                    category={item.category}
                    image={item.image}
                    href={item.href}
                    date={item.date}
                    views={item.views}
                />)}
            </SimpleGrid>

        </div>
    );
};
export default NewsCarousel;


const Card = ({ title, content, image, href, tags, category, date, views }) => {

    const current_date = getRelativeDate(date)

    return (
        <Link to={href} className="happening-card">
            <div className="hc-image">
                <div
                    w='100%'
                    style={{
                        width: "100%",
                        display: 'flex',
                        gap: ".2rem",
                        flexWrap: 'wrap',
                        position: "absolute",
                        top: "16px",
                        left: "16px",
                    }}
                >
                    {tags?.map((tag, idx) =>
                        <span key={idx} className="hc-badge">{tag}</span>
                    )
                    }
                </div>
                {image && <Image className="hc-image-content--background" src={image} alt={title} />}
            </div>
            <div className="hc-body">
                <div className="hc-meta">
                    <span>{current_date}</span>
                    <div className="hc-meta-dot"></div>
                    <span>{category}</span>
                </div>
                <div className="hc-title">{title}</div>
                <div className="hc-excerpt">{content}</div>
            </div>
            <div className="hc-footer">
                {(views > 4) && <span className="hc-interested" ><IconUsers size={14}/>{views} personas han visto esto</span>}
                <Link to={href} className="hc-link">Ver más →</Link>
            </div>
        </Link>
    )
}